import {Injectable} from '@angular/core';
import {SearchHelper} from "./search-helper";
import {ApiConfig} from "../../api";
import {AdnHttpService} from '../../../util/adn-http.service';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';
import {LocalUserProfile} from '../../../session/local-user-profile';



@Injectable()
export class LocationResource extends SearchHelper {
  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService,
    localUserProfile: LocalUserProfile
  ) {
    super(AdnHttp, authHttpInterceptor, ApiErrorHandler, localUserProfile, 'location');
  }

  // The municipalities (e.g. Swedish kommuner) of a country: [{id, scbCode, name, region}]
  municipalities(country: string) {
    return this.send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri('location/municipalities'),
      params: {country}
    });
  }

  // The member locations of one municipality, in search-result shape, ready to add to a named-location target
  municipalityLocations(municipalityId) {
    return this.send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri('location/municipalities/' + municipalityId + '/locations')
    });
  }
}
